module.exports = __webpack_public_path__ + "static/img/3.564d5af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/3.png
// module id = bEhl
// module chunks = 0